import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect, useRef } from "react";
import bgvideo from '../images/bgvideo.mp4';

// Custom Arrow Components
const NextArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute top-1/2 right-[-50px] transform -translate-y-1/2 
               bg-yellow-500 text-black p-3 rounded-full shadow-xl 
               opacity-70 hover:opacity-100 hover:bg-white hover:text-black 
               transition-all duration-300 z-10"
  >
    <FontAwesomeIcon icon={faCaretRight} className="text-3xl" />
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute top-1/2 left-[-50px] transform -translate-y-1/2 
               bg-yellow-500 text-black p-3 rounded-full shadow-xl 
               opacity-70 hover:opacity-100 hover:bg-white hover:text-black 
               transition-all duration-300 z-10"
  >
    <FontAwesomeIcon icon={faCaretLeft} className="text-3xl" />
  </button>
);

export default function HeaderCarousel({ content }) {

  const [isVisible, setIsVisible] = useState(false);
  const componentRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (componentRef.current) {
        const top = componentRef.current.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (top < windowHeight) {
          setIsVisible(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on mount in case the component is already in the viewport

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  console.log(content);
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    appendDots: dots => (
      <div>
        <ul className="flex absolute -bottom-5 left-1/2 -translate-x-1/2">{dots}</ul>
      </div>
    ),
    customPaging: i => (
      <div className="w-4 h-4 bg-gray-400 rounded-full mx-2 transition-all duration-300 hover:bg-[#FEE600]"></div>
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false
        },
      },
    ],
  };

  return (
    <section className={`h-[100vh] relative flex items-center justify-center transition-opacity duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`} ref={componentRef}>
      <video
        autoPlay
        muted
        loop
        playsInline
        class="absolute top-0 left-0 w-full h-full object-cover"
      >
        <source src={bgvideo} type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      <div className="w-[85%] relative z-10">
        <Slider {...settings}>
          {content.data.map((slide, index) => (
            <div key={index} className="w-full flex items-center justify-center px-6 md:px-20 mb-5">
              <div className="flex w-full items-center justify-between gap-10 flex-col md:flex-row">

                <div className="text-black w-full text-center md:text-left">
                  <h1 className="text-3xl md:text-6xl font-bold leading-tight text-white">
                    {slide.title}
                  </h1>
                  <p className="text-yellow-500 mt-4 md:text-4xl text-2xl font-bold">{slide.subtitle}</p>
                </div>

              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
